import script from "./NewSetNewPasswordView.vue?vue&type=script&setup=true&lang=ts"
export * from "./NewSetNewPasswordView.vue?vue&type=script&setup=true&lang=ts"

import "./NewSetNewPasswordView.vue?vue&type=style&index=0&id=ecbc5ea8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ecbc5ea8"]])

export default __exports__